import { memo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';
import { EllipsisIcon } from '@air/design-icons';

import { CardAction } from '~/components/CardAction';
import { AssetGalleryCardMenu } from '~/components/Gallery/AssetGalleryCard/AssetGalleryCardMenu';
import { type GetSelectionMenuOptionsType } from '~/components/Gallery/types';
import { type GetItemMenuOptions } from '~/constants/MenuOptions';
import { ASSET_CARD_SUB_MENU_BUTTON } from '~/constants/testIDs';

export type AssetGalleryCardRightActionsProps<C> = {
  clip: C;
  getItemMenuOptions: GetItemMenuOptions;
  getSelectionMenuOptions: GetSelectionMenuOptionsType;
  setIsMenuOpen: (isOpen: boolean) => void;
};

const _AssetGalleryCardRightActions = <C extends Clip | PublicClip>({
  clip,
  getItemMenuOptions,
  getSelectionMenuOptions,
  setIsMenuOpen,
}: AssetGalleryCardRightActionsProps<C>) => {
  return (
    <>
      <AssetGalleryCardMenu
        clip={clip}
        getItemMenuOptions={getItemMenuOptions}
        getSelectionMenuOptions={getSelectionMenuOptions}
        setIsMenuOpen={setIsMenuOpen}
        trigger={<CardAction data-testid={ASSET_CARD_SUB_MENU_BUTTON} icon={<EllipsisIcon size="sm" />} />}
      />
    </>
  );
};

// biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration
export const AssetGalleryCardRightActions = memo(_AssetGalleryCardRightActions) as typeof _AssetGalleryCardRightActions;
